<template>
	<div class="work-section">
		<div class="work-section__section">
			<h2 class="work-section__title">Monthly Reports</h2>
			<div class="work-section__content">
				<GenerateReport></GenerateReport>
			</div>
		</div>
		<div class="work-section__section">
			<h2 class="work-section__title">Download Reports</h2>
			<div class="work-section__content">
				<GenerateDownloadReport></GenerateDownloadReport>
			</div>
		</div>
		<div class="work-section__section">
			<h2 class="work-section__title">SLA Reports</h2>
			<div class="work-section__content">
				<GenerateSLAReport></GenerateSLAReport>
			</div>
		</div>
		<div class="work-section__section">
			<h2 class="work-section__title">Weekly SLA Reports</h2>
			<div class="work-section__content">
				<GenerateWeeklySLAReport></GenerateWeeklySLAReport>
			</div>
		</div>
		<div class="work-section__section">
			<h2 class="work-section__title">Bag Reports (Only RB)</h2>
			<div class="work-section__content">
				<GenerateRBBagReport></GenerateRBBagReport>
			</div>
		</div>
		<div class="work-section__section">
			<h2 class="work-section__title">UPS Reports</h2>
			<div class="work-section__content">
				<GenerateUPSReport></GenerateUPSReport>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import GenerateReport from "../components/report/GenerateReport.vue";
import GenerateDownloadReport from "../components/report/GenerateDownloadReport.vue";
import GenerateSLAReport from "../components/report/GenerateSLAReport.vue";
import GenerateUPSReport from "../components/report/GenerateUPSReport.vue";
import GenerateWeeklySLAReport from "../components/report/GenerateWeeklySLAReport.vue";
import GenerateRBBagReport from "../components/report/GenerateRBBagReport.vue";
//
export default Vue.extend({
	name: "Reports",
	components: {
		GenerateReport,
		GenerateDownloadReport,
		GenerateSLAReport,
		GenerateUPSReport,
		GenerateWeeklySLAReport,
		GenerateRBBagReport
	}
});
</script>

<style lang="scss" scoped>
.work-section {
	padding: 0 20px;

	&__section {
		border: $border-color 1px solid;
		border-radius: 5px;
		margin-top: 50px;
		width: 100%;
	}

	&__title {
		border-bottom: $border-color 1px solid;
		background-color: $color7;
		text-align: center;
		font-weight: 600;
		line-height: 27px;
		font-size: 16px;
		padding: 5px 0;
	}

	&__content {
		&--scroll {
			padding-left: 10px;
			height: 500px;
		}
	}
}
</style>